import React from "react";

const RiskPage = () => {
  return (
    <div className="legal-page">
      <h1>Risk Disclosure</h1>
      <p className="legal-muted">
        Trading forex, indices, commodities, cryptocurrencies, and other
        leveraged products involves a high level of risk and may not be
        suitable for all investors. This disclosure is a general summary and
        does not constitute personal investment advice.
      </p>

      <section>
        <h2>1. Market Risk</h2>
        <p>
          Prices of financial instruments can move rapidly and unpredictably due
          to economic, political, or sentiment-driven factors. You may lose part
          or all of the capital you deploy.
        </p>
      </section>

      <section>
        <h2>2. Leverage Risk</h2>
        <p>
          Leverage amplifies both profits and losses. Small price movements can
          result in disproportionately large gains or losses when using high
          leverage.
        </p>
      </section>

      <section>
        <h2>3. Past Performance</h2>
        <p>
          Past performance of a Trader or Analyst does not guarantee future
          results. AlphaRank scores and metrics are tools for analysis only and
          must not be interpreted as a guarantee of profit.
        </p>
      </section>

      <section>
        <h2>4. Third-Party Brokers</h2>
        <p>
          Trade execution occurs via third-party brokers. Any risks related to
          execution quality, slippage, system outages, or regulatory status of
          the broker are outside the direct control of CrunchAlpha.
        </p>
      </section>

      <section>
        <h2>5. No Investment Advice</h2>
        <p>
          Information, signals, and analytics presented on CrunchAlpha do not
          constitute investment advice, solicitation, or recommendation tailored
          to your personal financial situation. You are solely responsible for
          any trading decisions you make.
        </p>
      </section>

      <section>
        <h2>6. Acknowledgement</h2>
        <p>
          By using the platform, you acknowledge that you understand and accept
          these risks and that CrunchAlpha shall not be held liable for losses
          arising from your trading activities.
        </p>
      </section>
    </div>
  );
};

export default RiskPage;
